import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { ProgressIndicator } from '../../components/ProgressIndicator/ProgressIndicator';
import { Button } from '../../components/Button/Button';
import { copy, labels } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';
import type { HelpType } from '../../types';

export const HelpTypeScreen: React.FC = () => {
  const navigate = useNavigate();
  const { updateData, setStep } = useOnboardingStore();

  const handleSelect = (value: HelpType) => {
    updateData({ help_type: value });
    setStep(4);
    navigate('/concerns');
  };

  return (
    <Screen>
      <ProgressIndicator currentStep={3} totalSteps={8} />
      
      <ScreenHeader
        title={copy.helpType.title}
        subtitle={copy.helpType.subtitle}
      />
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => handleSelect('specialist')}
        >
          {labels.helpType.specialist}
        </Button>
        
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => handleSelect('peer-group')}
        >
          {labels.helpType['peer-group']}
        </Button>
        
        <Button
          variant="outline"
          size="large"
          fullWidth
          onClick={() => handleSelect('not-sure')}
        >
          {labels.helpType['not-sure']}
        </Button>
      </div>
    </Screen>
  );
};
